<template>
  <div class="q-pa-sm">
    <div
      class="q-ma-sm"
      :class="this.$q.dark.mode === true ? '' : 'text-primary'"
    >
      <span class="text-h6 text-weight-bold">
        {{ title }}
      </span>
    </div>
    <q-dialog v-model="saveModelDialog" persistent style="width: 800px">
      <q-card>
        <q-bar class="bg-primary text-white">
          Save as
          <q-space />
          <q-btn v-close-popup text-color="white" dense size="sm" icon="close">
            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
          </q-btn>
        </q-bar>

        <q-card-actions align="right" class="q-pa-md">
          <q-input label="Model Name" v-model="modelName"></q-input>
          <q-btn
            flat
            label="Save"
            color="primary"
            v-close-popup
            :disable="modelName == null || modelName == ''"
            @click="submitSetup()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <PackageAuth>
      <template #authorized-content>
        <CustomSignalProForms
          :v2="true"
          :props_setup_type="setup_type"
          :setDataFromBackend="false"
          :isSaveModelPage="isSaveModelPage"
          @buySignals="(e) => (customBuySignal = e)"
          @sellSignals="(e) => (customSellSignal = e)"
          @indicators="(e) => (setupIndicators = e)"
          @fundamentalScan="(e) => (fundamentalScanData = e)"
          @isFundamentalScan="(e) => (isFundamentalScan = e)"
        />

        <q-card class="row q-mt-md">
          <div class="col-md-4 col-12">
            <q-card flat bordered class="row q-my-xs">
              <div class="col-6 q-pa-xs">
                <q-select
                  outline
                  v-model="selectedSector"
                  :options="optionSectors"
                  dense
                  label="Choose sector"
                  single
                  input-debounce="0"
                  option-label="name"
                  option-value="symbol"
                  class="q-mx-sm ellipsis"
                  :menu-absolute="true"
                />
              </div>
              <div class="col-6 q-py-md q-px-sm">
                <q-checkbox
                  dense
                  class="q-pr-sm ellipsis"
                  v-model="mySignals"
                  color="blue-5"
                  keep-color
                  label="My Signals"
                >
                  <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
                </q-checkbox>
              </div>
            </q-card>
            <ListCard
              class="q-mb-sm"
              :name="'Green Signal'"
              :data="computedCustomBuySignal"
              :type="'buy'"
              :loading="loading"
              :activeSymbol="symbol"
              @clickSymbol="
                (eSymbol) => {
                  symbol = eSymbol;
                }
              "
            />
            <ListCard
              :name="'Red Signal'"
              :data="computedCustomSellSignal"
              :type="'sell'"
              :loading="loading"
              :activeSymbol="symbol"
              @clickSymbol="
                (eSymbol) => {
                  symbol = eSymbol;
                }
              "
            />
          </div>

          <div
            class="q-pl-md-md q-mt-md q-mt-md-none col-md-8 col-sm-12 col-12"
          >
            <TradingViewMini
              v-if="symbol"
              :symbol="symbol"
              :enableDailyWeeklyIntraday="true"
              :indicators="setupIndicators"
            />
          </div>
        </q-card>
        <AccumulationDistributionComponents v-if="symbol" :symbol="symbol" />
      </template>
    </PackageAuth>
  </div>
</template>

<script>
import { ref, computed, watch, onUnmounted, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar, LocalStorage } from "quasar";
import useCore from "src/use/core";
import useUtils from "src/use/utils";
import useMembership from "src/use/membership";
import useCustomsignal from "src/use/customsignal";
import CustomSignalProForms from "src/components/CustomSignalProV2Components/CustomSignalProForms.vue";
import ListCard from "src/components/ListCard.vue";
import TradingViewMini from "src/components/Tradingview/TradingViewMini.vue";
import AccumulationDistributionComponents from "src/components/AccumulationDistributionComponents/AccumulationDistributionComponents";

import PackageAuth from "src/components/Packages/PackageAuth.vue";
export default {
  name: "CustomSignalProV2",

  components: {
    CustomSignalProForms,
    TradingViewMini,
    ListCard,
    AccumulationDistributionComponents,
    PackageAuth,
  },
  props: {
    isSaveModelPage: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Custom Signal Pro",
    },
  },
  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const { allSector } = useCore();
    const { getPackage, getPackageStatus } = useMembership();
    const {
      getSavedCustomSignal,
      customSignalProV2New,
      customSignalProV2NewSave,
    } = useCustomsignal();
    const savedCustomSignalPro = ref([]);
    const avaliablePackageList = ref([]);
    const setup_type = ref("buy");
    const asOfDate = ref("");
    const to_date = ref("");
    const from_date = ref("");
    const signal_type = ref("Single");
    const symbol = ref(null);
    const loading = ref(true);
    const mySignals = ref(false);
    const packageDetail = ref({});
    const myStockList = ref([]);
    const setupIndicators = ref([]);
    let selectedSymbol = ref("");
    const { utilsOptionSectors } = useUtils();
    const optionSectors = ref(utilsOptionSectors());
    const allStocks = ref([]);
    const selectedSector = ref(optionSectors.value[0]);
    const setup_sector = ref(optionSectors.value[0]);
    const sectorWiseStock = ref({});
    store.dispatch("core/getAllStocks").then(() => {
      allStocks.value = store.state.core.allStocks;
    });

    allSector().then((res) => {
      sectorWiseStock.value = res.data.reduce((result, item) => {
        const stockSymbols = item.stocks.map((stock) => stock.symbol);
        result[item.id] = stockSymbols;
        return result;
      }, {});
    });

    if (store.state.authenticate.isAuthenticated) {
      if (LocalStorage.getItem("package") != null) {
        packageDetail.value = LocalStorage.getItem("package");
        myStockList.value = packageDetail.value.stocks;
      } else {
        getPackage()
          .then((res) => {
            packageDetail.value = res.data;
            myStockList.value = packageDetail.value.stocks;
            loading.value = false;
          })
          .catch((err) => {
            packageDetail.value = null;
          });
      }
    }

    const customTableData = ref({});
    const customBuySignal = ref([]);
    const customSellSignal = ref([]);
    const fundamentalScanData = ref([]);
    const isFundamentalScan = ref([]);

    let modelName = ref("");
    let saveModelDialog = ref(false);
    let savedCustomSignalData = ref("");

    const getAsof = () => {
      asOfDate.value = store.state.market.asOf.replaceAll("/", "-");
      to_date.value = asOfDate.value;
      from_date.value = new Date(
        new Date(asOfDate.value).setFullYear(
          new Date(asOfDate.value).getFullYear() - 1
        )
      )
        .toISOString()
        .substring(0, 10);
    };

    onMounted(() => {
      if (store.state.market.asOf) {
        getAsof();
      } else {
        store.dispatch("market/marketStatusNew").then(() => {
          getAsof();
        });
      }
    });

    const computeCustomSignal = (signalType) =>
      computed(() => {
        const selectedSectorId = selectedSector.value.id;
        const sectorStocks = sectorWiseStock.value[selectedSectorId];
        const isMyStockListAvailable = mySignals.value && myStockList.value;

        return signalType.value.filter((symbol) => {
          const isSectorMatch =
            selectedSectorId === 0 || sectorStocks?.includes(symbol);
          const isMyStock =
            !isMyStockListAvailable || myStockList.value.includes(symbol);
          const isFundamentalScanPro =
            !isFundamentalScan.value ||
            fundamentalScanData.value.includes(symbol);

          const mutualFunds = new Set([13, 14, 15]);

          const excludeMutualFund = allStocks.value.some(
            (stock) => stock.symbol === symbol && !mutualFunds.has(stock.sector)
          );

          return (
            isSectorMatch &&
            isMyStock &&
            isFundamentalScanPro &&
            excludeMutualFund
          );
        });
      });

    const computedCustomBuySignal = computeCustomSignal(customBuySignal);
    const computedCustomSellSignal = computeCustomSignal(customSellSignal);
    watch([computedCustomBuySignal, computedCustomSellSignal], (newValues) => {
      symbol.value = newValues[0][0] || newValues[1][0];
    });

    return {
      setupIndicators,
      computedCustomBuySignal,
      computedCustomSellSignal,
      avaliablePackageList,
      savedCustomSignalPro,
      setup_type,
      setup_sector,
      from_date,
      to_date,
      signal_type,
      customTableData,
      customBuySignal,
      customSellSignal,
      symbol,
      loading,
      modelName,
      saveModelDialog,
      savedCustomSignalData,
      optionSectors,
      selectedSector,
      mySignals,
      fundamentalScanData,
      isFundamentalScan,
    };
  },
};
</script>
